module.exports = __webpack_public_path__ + "static/media/questionnaires-card.05ee4e54.png";